/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Leveling_Faq_Bots_QInputs */



/**
* | output |
* | --- |
* | "Which bots can I import from?" |
*
* @param {Products_Leveling_Faq_Bots_QInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_faq_bots_q = /** @type {((inputs?: Products_Leveling_Faq_Bots_QInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_Faq_Bots_QInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Из каких ботов можно перенести уровни?")
	return /** @type {LocalizedString} */ ("Which bots can I import from?")
});